<div class="container" *ngIf="!isLoading">
    <div class="header">
        <div class="title">{{ 'matrix.library.dialog.title' | translate }}</div>
    </div>
    <div class="main">
        <div class="side-menu">
            <div class="library-container">
                <div class="library-list-title">
                    {{ 'matrix.library.dialog.sub-title.library' | translate }}
                </div>
                <div class="library-list">
                    <div
                        class="item"
                        *ngFor="let library of data.libraryList"
                        [class.select]="selectedLibrary?.id === library.id"
                        (click)="selectLibrary(library)">
                        <div class="title">
                            <mat-icon class="icon title-icon" svgIcon="mimics"></mat-icon>
                            <span class="name">{{ library.name }}</span>
                        </div>
                        <mat-icon class="icon arrow" svgIcon="dropdown-arrow"></mat-icon>
                    </div>
                </div>
            </div>
        </div>
        <div class="side-menu" *ngIf="selectedLibrary">
            <div class="category-container">
                <div class="library-list-title">
                    {{ 'matrix.library.dialog.sub-title.category' | translate }}
                </div>
                <div class="category-list">
                    <div
                        class="item"
                        *ngFor="let category of selectedLibraryCategoryList"
                        [class.select]="selectedCategory?.id === category.id"
                        (click)="selectCategory(category)">
                        <div class="title">
                            <span class="name">{{ category.name }}</span>
                        </div>
                        <mat-icon class="icon arrow" svgIcon="dropdown-arrow"></mat-icon>
                    </div>
                </div>
            </div>
        </div>
        <div class="side-menu" *ngIf="selectedCategory">
            <div class="component-container">
                <app-library-component-dialog
                    class="component-dialog"
                    [class.hidden]="!showComponentDialog"
                    [x]="0"
                    [y]="0"
                    [selectedCategory]="selectedCategory"
                    [selectedComponent]="selectedComponent"
                    [componentList]="selectedComponentList"
                    [whiteMode]="true"
                    [isSettingCondition]="true"
                    (onSelectComponent)="selectComponent($event)"></app-library-component-dialog>
            </div>
        </div>
    </div>
    <div class="footer">
        <div class="button-container">
            <button class="text-button" (click)="close()">
                {{ 'dlg.cancel' | translate }}
            </button>
            <app-button
                [disable]="isSelectButtonDisabled()"
                [text]="'matrix.library.dialog.sub-title.select-button'"
                customFontFamily="NotoSans-SemiBold"
                size="small"
                customFontSize="14px"
                (onClick)="select()"></app-button>
        </div>
    </div>
</div>

<app-loading-spinner
    *ngIf="isLoading"
    class="spinner-component"
    [custom]="true"
    size="80"
    strokeWidth="3"></app-loading-spinner>
